export default "__VITE_ASSET__BxqigYW3__"